import { Box, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import dayjs from 'dayjs';
import { useContext, useState } from 'react';
import CommentsWrap from '@/components/comments_components/CommentsWrap';
import RequiredIndicator from '@/components/common/RequiredIndicator';
import { CurrentApplicationContext } from '@/Contexts/CurrentApplicationContext';
import useQuestions from '@/hooks/useQuestions';
import { QuestionProps } from '@/models/Question';
import { logError } from '@/utils/errorHandlerUtil';

function DateQuestion({ question }: { question: QuestionProps }) {
  const { getMinDate, getMaxDate, validDateTime } = useQuestions();
  const { answers, makingApiRequest, canEdit, saveApplicationAnswer2, applicationCycle } =
    useContext(CurrentApplicationContext);
  const [timer, setTimer] = useState<number | null>(null);

  const questionAnswer = answers[question.id];
  const [currentValue, setCurrentValue] = useState(questionAnswer?.responseDate ?? null);

  const handleChanged = (newValue: dayjs.Dayjs | null) => {
    if (!validDateTime(question, applicationCycle!, newValue)) return;

    let dateValue = null;
    try {
      dateValue = newValue ? newValue?.toISOString() : null;
    } catch (err) {
      logError(`Date Question - date conversion error. Raw value: ${newValue}`, err);
    }

    setCurrentValue(dateValue);
    //create a 2 second delay before saving the answer

    if (timer) clearTimeout(timer);

    const newTimer = setTimeout(async () => {
      await saveApplicationAnswer2(question, dateValue);
    }, 2500);

    setTimer(newTimer);
  };

  return (
    <Box display='flex' width='100%' justifyContent='space-between' alignItems='start'>
      <Box display='flex' flexDirection='column' gap='10px'>
        <Typography
          color='textSecondary'
          style={{
            marginTop: '15px',
          }}
        >
          {question.questionText} {question.questionNeeded ? <RequiredIndicator /> : ''}
        </Typography>
        <Box width='70%'>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              disabled={!canEdit || makingApiRequest}
              value={dayjs(currentValue)}
              onChange={handleChanged}
              maxDate={getMaxDate(question, applicationCycle)}
              minDate={getMinDate(question, applicationCycle)}
            />
          </LocalizationProvider>
        </Box>
      </Box>
      <CommentsWrap question={question} />
    </Box>
  );
}

export default DateQuestion;
